import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay, Navigation } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'

SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation])
Vue.use(getAwesomeSwiper(SwiperClass))

import 'swiper/swiper-bundle.css'
import './assets/index.css';
import FullCalendar from 'vue-full-calendar'

Vue.config.productionTip = false;
Vue.use(FullCalendar)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
